import CompetencyRequirementsDialog from './CompetencyRequirementsDialog';
export default CompetencyRequirementsDialog;